export default function getDateString(date) {
  const [ year, month, day ] = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  ];

  return`${year}-${(""+month).padStart(2,0)}-${(""+day).padStart(2,0)}`;
}

export function getDateStdString(date) {
  const [ year, month, day ] = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  ];

  return `${(""+month).padStart(2,0)}/${(""+day).padStart(2,0)}/${year}`;
}

export function parseDateString(dateStr) {
  const [ year, month, day ] = dateStr.split("-");

  return new Date(`${month}/${day}/${year}`);
}